export default "__VITE_ASSET__Cqe9c0Pe__"